/**
 * This Javascript is responsible of rendering the notification when the site is not yet published
 */

var features = require('diy/util/features');
var maintenanceMode = require('diy/maintenanceMode/maintenanceMode');
var $ = require('jquery');

exports.init = function() {
    var n = diy.editor.notifications;
    n.api.ready(function() {
        var notPublishedNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_NOT_PUBLISHED);
        if (!(maintenanceMode.getState() && maintenanceMode.isFirstPublish())
            // Don't show this notification if we already have the no domain notification on
            || !features('domainConnected')
            || !jimdoData.notificationData.notPublished.show) {

            if (notPublishedNotifications.length > 0) {
                n.api.deleteNotificationByType(n.Notifications.TYPE_NOT_PUBLISHED);
            }
        } else {
            if (!jimdoData.notificationData.notPublished.triggerShow) {
                return;
            }

            if (notPublishedNotifications.length > 0) {
                n.api.updateNotification(notPublishedNotifications[0].getId(), { dismissed: 0 });
            } else {
                n.api.createNotification({type: n.Notifications.TYPE_NOT_PUBLISHED});
            }
        }
    });

    $(document).bind('diy-maintenance-mode-publish diy-guidedsetup-steps-completed', function() {
        var notPublishedNotifications = n.api.getNotificationsByType(n.Notifications.TYPE_NOT_PUBLISHED);
        if (notPublishedNotifications.length > 0) {
            n.api.deleteNotificationByType(n.Notifications.TYPE_NOT_PUBLISHED);
        }
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/init/notpublishednotification.js
 ** module id = 667
 ** module chunks = 0
 **/